import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
// import illustration from '../assets/illustration.svg'; // Adjust the path as needed

interface SecondStepProps {
  onStartCampaign: () => void;
  campaign: 'sms' | 'mms'
}

type Step = {
  title: string
  subTitle: string
}

const steps: Record<'sms' | 'mms', Step[]> = {
  'sms': [
    {
      title: 'Name Your Campaign',
      subTitle: 'Choose a clear name so you can easily compare results later.'
    },
    {
      title: 'Upload Your Contacts',
      subTitle: 'Upload your contact list. Add tags for easy identification. Cellcast automatically validates and dedupes to keep lists clean - and unlike others, we don`t charge per stored contact.'
    },
    {
      title: 'Choose Your Sender Information',
      subTitle: 'Send from a phone number or a branded sender ID.'
    },
    {
      title: 'Create Your Message Content',
      subTitle: 'Craft an engaging SMS campaign with personalisation fields and links. Use tracking links to measure engagement.'
    }
  ],
  'mms': [
    {
      title: 'Name Your Campaign',
      subTitle: 'Choose a clear name so you can easily compare results later.'
    },
    {
      title: 'Upload Your Contacts',
      subTitle: 'Upload your contacts. Add tags for easy identification. Cellcast automatically validates and dedupes to keep lists clean - and unlike others, we don`t charge per stored contact.'
    },
    {
      title: 'Create Your Message Content',
      subTitle: 'Craft an engaging MMS campaign with personalisation fields, images, and links. Use tracking links to measure engagement.'
    }
  ]
}

const SecondStep: React.FC<SecondStepProps> = ({ onStartCampaign, campaign }) => {
  const type = (campaign?.toLowerCase() ?? 'sms') as 'sms' | 'mms'

  return (
    <div className="d-flex  align-items-center" style={{ minHeight: "calc(100vh - 130px)" }}>
      <Card className="rounded-4 w-100">
        <div className="d-flex flex-column h-100 p-14">
          <h2 className="display-6 fw-bold text-gray-800">
            How To Create {campaign} campaign
          </h2>
          <p className="fs-4 text-gray-700 fw-light">
            Set up in 10 minutes. Start capturing more leads today.
          </p>

          <div className="d-flex justify-content-between align-items-center mt-8 gap-4">
            <div className="list-steps d-flex flex-column gap-4 w-50" style={{paddingLeft: '30px'}}>
             {steps[type]?.map((step, index) => (
               <div key={index} className="mb-4 d-flex gap-2">
                <h2 className="fs-4 fw-bold text-gray-800 text-nowrap">{index + 1}.</h2>
                <div>
                  <h2 className="fs-4 fw-bold text-gray-800">{step?.title}</h2>
                  <p className="fs-7 text-gray-700">
                    {step?.subTitle}
                  </p>
                </div>
              </div>
             ))}
            </div>
            <div className="w-50 d-flex justify-content-center align-items-center">
              <video 
                className="h-350px" 
                autoPlay 
                loop 
                muted 
                playsInline
              >
                <source src={toAbsoluteUrl('/media/onboarding/campaign-flow.mp4')} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </div>
        
        <div className='border border-gray-300 border-1' />

        <div className="mt-8 pb-8 px-14">
          <Button variant="primary" size="lg" onClick={onStartCampaign}>
            Start Create Now
          </Button>
        </div>
      </Card>
    </div>

  );
};


export default SecondStep;